import type { ColumnProps } from '@react-types/table';
import styles from '@danske/sapphire-css/components/table/table.module.css';

export type ColSizeProps = Pick<
  ColumnProps<any>,
  'maxWidth' | 'minWidth' | 'width'
>;
export type ColumnAlignment = 'left' | 'center' | 'right';

export function getAlignmentStyles(
  align?: ColumnAlignment
): Record<string, boolean> {
  return {
    [styles['sapphire-table__cell--alignLeft']]:
      align === 'left' || align === undefined,
    [styles['sapphire-table__cell--alignCenter']]: align === 'center',
    [styles['sapphire-table__cell--alignRight']]: align === 'right',
  };
}
